import * as React from 'react';

//static generic components
import './styles.scss';
import BodyPortal from '../BodyPortal';

const Loader = (props) => {
    if (props.isLoading) {              //shoe loader when isLoading prop is true
        return (
            <BodyPortal className="loader_contr">
                <div className="app-loader">
                    <div className="loader_img"></div>
                </div>
            </BodyPortal>
        );
    } else {
        return null;
    }
};

export default Loader;
